module.exports = __webpack_public_path__ + "static/img/top_img1.7bda63a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/service/top_img1.png
// module id = PEM9
// module chunks = 1